// src/hooks/usePageTracking.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: any[];
    fbq?: (...args: any[]) => void;
  }
}

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      const pagePath = location.pathname + location.search;

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'pageview',
          pagePath,
        });
      }

      if (typeof window.fbq === 'function') {
        window.fbq('track', 'PageView');
      }
    } catch (err) {
      console.error('Page tracking error:', err);
    }
  }, [location]);
};
